/**
 * Email Protection Utilities
 * 
 * Provides client-side email and phone number obfuscation to prevent bot scraping.
 * Email and phone numbers are split into parts and reconstructed using JavaScript,
 * making them invisible to bots that parse static HTML.
 * 
 * @module utils/emailProtection
 */

/**
 * Reconstructs email address from separate parts
 * @param user - Username part (before @)
 * @param domain - Domain name (between @ and .)
 * @param tld - Top-level domain (after last .)
 * @returns Complete email address
 */
export const reconstructEmail = (user: string, domain: string, tld: string): string => {
  return `${user}@${domain}.${tld}`;
};

/**
 * Reconstructs phone number from separate parts
 * @param parts - Array of phone number parts
 * @returns Complete phone number
 */
export const reconstructPhone = (parts: string[]): string => {
  return parts.join('');
};

/**
 * Protected email data for contact@oceannova.pl
 */
export const PROTECTED_EMAIL = {
  user: 'contact',
  domain: 'oceannova',
  tld: 'pl',
};

/**
 * Protected phone data for +48 696 435 651
 */
export const PROTECTED_PHONE = {
  parts: ['+48', ' ', '696', ' ', '435', ' ', '651'],
  linkParts: ['+48', '696', '435', '651'],
};

/**
 * Get display email address
 */
export const getEmail = (): string => {
  return reconstructEmail(PROTECTED_EMAIL.user, PROTECTED_EMAIL.domain, PROTECTED_EMAIL.tld);
};

/**
 * Get display phone number
 */
export const getPhone = (): string => {
  return reconstructPhone(PROTECTED_PHONE.parts);
};

/**
 * Get phone link (tel:) format
 */
export const getPhoneLink = (): string => {
  return reconstructPhone(PROTECTED_PHONE.linkParts);
};
